import { media } from '@app/styles/themes/constants';
import { Layout } from 'antd';
import styled, { css } from 'styled-components';

const { Content } = Layout;

interface HeaderProps {
  $isTwoColumnsLayout: boolean;
}

export default styled(Content)<HeaderProps>`
  padding: 0;
  overflow: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 1rem;
  width: 100%;

  @media only screen and (${media.md}) {
    padding: 0;
  }

  @media only screen and (${media.xl}) {
    ${(props) =>
      props?.$isTwoColumnsLayout &&
      css`
        padding: 0;
      `}
  }

  .ant-table-wrapper {
    background-color: transparent;
    padding: 1rem;
    /* margin: 1rem; */
  }
`;
